import { BaseAccommodationType, OccupationFilterType, OccupationType } from "./Occupancy.entity";

export class OccupancyOptionsEntity {
  private constructor(
    readonly occupationType: OccupationType,
    readonly occupationFilterType: OccupationFilterType,
    readonly minChildrenAge: number | null,
    readonly maxChildrenAge: number | null,
    readonly minBabiesAge: number | null,
    readonly maxTeensAge: number | null,
    readonly maxSeniorsAge: number | null,
    readonly filterByAge: boolean,
    readonly baseAccommodationType: BaseAccommodationType
  ) {}

  static fromMap(configurationsMap: [string, string][]) {
    const configMap = new Map(configurationsMap);
    return new OccupancyOptionsEntity(
      configMap.get("occupationType") as OccupationType,
      configMap.get("fltr_tipo_ocupacion") as OccupationFilterType,
      configMap.has("minedadnino") ? Number(configMap.get("minedadnino")) : null,
      configMap.has("maxedadnino") ? Number(configMap.get("maxedadnino")) : null,
      configMap.has("babyMinAge") ? Number(configMap.get("babyMinAge")) : null,
      configMap.has("teenagerMaxAge") ? Number(configMap.get("teenagerMaxAge")) : null,
      configMap.has("adultMaxAge") ? Number(configMap.get("adultMaxAge")) : null,
      configMap.get("filterGuestsByAge") === "1",
      (configMap.get("baseAccommodationType") as BaseAccommodationType) ??
        BaseAccommodationType.ADULTS_TYPE
    );
  }
}
